import { render, staticRenderFns } from "./SVGSprite.vue?vue&type=template&id=06358a7e&functional=true&"
import script from "./SVGSprite.vue?vue&type=script&setup=true&lang=js&"
export * from "./SVGSprite.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports